// Zod never compiles a schema with `new Function`: the SPA's Content-Security-Policy allows no
// evaluated script (spec F3 decision 40). Imported first by main.tsx, before any schema parses;
// without it, Zod's probe for eval is refused (a console report) and it falls back the same way.
import { z } from "zod";

z.config({ jitless: true });
